import { WRITE_KEY, SOURCE_KEY } from '@/js/constants/cohesion';

export const cohesionSnippet = {
  tagular: {
    apiKey: 'e1f374e9-08d8-4f42-a744-ddfdaee997dd',
    writeKey: WRITE_KEY,
    sourceKey: SOURCE_KEY,
    taggy: { enabled: true }
  },
  monarch: {
    sourceId: '088adec0-65af-49ae-98b3-337ab58d4f6b',
    token: 'e9584f8a-2739-486b-a11e-2b176f158cd2',
    autoRequest: {
      enabled: true,
      suppressPlacements: true
    }
  },
  fuse: {
    leases: [ { pool: 'qEk6PrZcJoSyErMUQX2pLj' } ],
    metadata: {
      vdn: '68231'
    }
  },
  consent: {
    required: false
  }
};
